import React from 'react';

import UserShow from './CrudOparetor/UserShow';
import Footer from './Footer';
import HomeFirst from './HomeFirst';
import Joke from './Joke/Joke';
import MenuSetup from './Menu/MenuSetup';

import QusitionSetup from './Qusition/QusitionSetup';
import RevewSetup from './Revew/RevewSetup';
import TabSetup from './TabComponent/TabSetup';
import TourSetUp from './TourComponent/TourSetUp';
import WordSetUp from './Word/WordSetUp';

const Home = () => {

    return (
        <div>
            <HomeFirst></HomeFirst>
            <MenuSetup></MenuSetup>
            <Joke></Joke>
            <TourSetUp></TourSetUp>
            <WordSetUp />
            <TabSetup></TabSetup>
            <UserShow></UserShow>
            <RevewSetup></RevewSetup>
            <QusitionSetup></QusitionSetup>
            <Footer></Footer>
        </div>
    );
};

export default Home;